import { createContext, useContext } from 'react';

import { InternalLinkTarget } from '../internalLinks';

/**
 * Returns a click handler for internal-link targets the host surface wants to
 * handle in place (instead of the default route navigation), or null to let
 * the default behavior apply. E.g. the chat side content pane claims
 * document-summary record links and opens them beside the transcript.
 * Consumed by useInternalLinkClickHandler, which resolves a href through the
 * full chain: interceptor → route navigation → plain text.
 *
 * Must be pure: the renderer calls it during render to decide whether the
 * label is a link or plain text, so side effects belong in the returned
 * handler, never in the interceptor itself.
 */
export type InternalLinkInterceptor = (
  target: InternalLinkTarget
) => (() => void) | null;

export const InternalLinkInterceptorContext =
  createContext<InternalLinkInterceptor | null>(null);

export function useInternalLinkInterceptor() {
  return useContext(InternalLinkInterceptorContext);
}
